import SharedExportOptionsSection from '../../shared/ExportOptionsSection';

import { useStore } from '../batchComicUploadStore';

export default function ExportOptionsSection() {
  const store = useStore();
  const {
    jobName,
    jobNameValidationError,
    fileType,
    frameRate,
    keyframeSimplification,
    includeMesh,
  } = store.state;

  return (
    <SharedExportOptionsSection
      jobName={jobName}
      jobNameRequired
      jobNameError={jobNameValidationError}
      fileType={fileType}
      frameRate={frameRate}
      keyframeSimplification={keyframeSimplification}
      includeMesh={includeMesh}
      onJobNameChange={(v) => store.updateJobName(v)}
      onFileTypeChange={(v) => store.updateFileType(v)}
      onFrameRateChange={(v) => store.updateFrameRate(v)}
      onKeyframeSimplificationChange={(v) =>
        store.updateKeyframeSimplification(v)
      }
      onIncludeMeshChange={(v) => store.updateIncludeMesh(v)}
    />
  );
}
